<template>
  <div class="hidden-xs">
    <div id="leaf" class="top-right hidden-xs">
      <img src="../assets/leaf.png" alt="Leaf" />
    </div>
    <div id="flower-2" class="bottom-right">
      <img src="../assets/flower_2.png" alt="flower 2" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Right',
  data () {
    return {
      msg: ''
    }
  }
}

</script>

<style lang="scss">
%fixed-auto {
  position: fixed;
  z-index: -1;
  width: auto;
  height: auto;
  opacity: 0.7;
}

%top70 {
  top: 70px;
}

%bottom0 {
    bottom: 0;
}

%right0 {
  right: 0;
}

.bottom-right {
  @extend %fixed-auto;
  @extend %bottom0;
  @extend %right0;
}

.top-right {
 @extend %fixed-auto;
 @extend %top70;
 @extend %right0;
 // transform: scaleY(-1);
}
</style>



// WEBPACK FOOTER //
// src/components/Right.vue